import React from 'react';
import { Box, Typography, Link as MuiLink, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { currentLang } = useLanguage();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            direction: currentLang === 'he' ? 'rtl' : 'ltr',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <MuiLink
              component={RouterLink}
              to="/about"
              color="inherit"
              underline="hover"
            >
              {t('footer.about')}
            </MuiLink>
            <MuiLink
              component={RouterLink}
              to="/contact"
              color="inherit"
              underline="hover"
            >
              {t('footer.contact')}
            </MuiLink>
            <MuiLink
              component={RouterLink}
              to="/terms"
              color="inherit"
              underline="hover"
            >
              {t('footer.terms')}
            </MuiLink>
          </Box>
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} {t('footer.copyright')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}; 